module.exports = __webpack_public_path__ + "img/icon1.4dc22fd.png";